module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.show) ? _c('div', [_vm._m(0), _vm._v(" "), _c('h4', [_vm._v("\n    Found "), _c('span', {
    staticStyle: {
      "color": "blue"
    }
  }, [_vm._v(_vm._s(_vm.count))]), _vm._v(" Products by searching\n    "), (_vm.category) ? _c('span', {
    staticStyle: {
      "color": "brown"
    }
  }, [_vm._v("category : " + _vm._s(_vm.category.name))]) : _vm._e(), _vm._v(" "), (_vm.keyword) ? _c('span', {
    staticStyle: {
      "color": "green"
    }
  }, [_vm._v(" keyword :" + _vm._s(_vm.keyword))]) : _vm._e()]), _vm._v(" "), _c('table', {
    staticClass: "ui celled table productslist"
  }, [_c('thead', [_c('tr', [_c('th', [_vm._v("Id")]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Image')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Name')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Reference')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Category')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Combinations')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Price')))]), _vm._v(" "), _c('th', [_vm._v(_vm._s(_vm.$t('Ops')))])])]), _vm._v(" "), _c('tbody', [(_vm.searching) ? _c('tr', [_vm._m(1)]) : _vm._e(), _vm._v(" "), _vm._l((_vm.products), function(product) {
    return _c('tr', {
      key: product.id_product,
      staticClass: "product",
      attrs: {
        "id": 'customer_' + _vm.currentCustomer.id + '_product_' + product.id_product
      }
    }, [_c('td', [_vm._v("\n          " + _vm._s(product.id_product) + "\n        ")]), _vm._v(" "), _c('td', [(product.product_image) ? _c('img', {
      attrs: {
        "src": product.product_image
      }
    }) : _vm._e()]), _vm._v(" "), _c('td', [_c('a', {
      attrs: {
        "href": product.front_office_link
      }
    }, [_vm._v(_vm._s(product.name))])]), _vm._v(" "), _c('td', [(product.reference) ? _c('span', {
      staticStyle: {
        "color": "black"
      }
    }, [_vm._v(_vm._s(product.reference))]) : _c('span', {
      staticStyle: {
        "color": "orange"
      }
    }, [_vm._v("N/A ")])]), _vm._v(" "), _c('td', [_vm._v("\n          " + _vm._s(product.category) + "\n        ")]), _vm._v(" "), _c('td', [(Object.keys(product.combinations).length > 0) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (_vm.id_combination[product.id_product]),
        expression: "id_combination[product.id_product]"
      }],
      staticClass: "ui fluid dropdown selection",
      staticStyle: {
        "height": "40px"
      },
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(_vm.id_combination, product.id_product, $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((product.combinations), function(combination) {
      return _c('option', {
        key: combination.id_product_attribute,
        domProps: {
          "value": combination.id_product_attribute,
          "selected": combination.default_on == '1' ? 'selected' : ''
        }
      }, [_vm._v("\n              " + _vm._s(combination.attributes) + " - " + _vm._s(combination.price_tax_incl) + " €\n            ")])
    }), 0) : _c('span', {
      staticStyle: {
        "color": "orange"
      }
    }, [_vm._v("N/A")])]), _vm._v(" "), _c('td', [_vm._v(_vm._s(product.formatted_price))]), _vm._v(" "), _c('td', {
      staticClass: "right aligned"
    }, [_c('button', {
      staticClass: "ui button icon blue",
      attrs: {
        "title": "Add this product"
      },
      on: {
        "click": function($event) {
          return _vm.addToCart(product)
        }
      }
    }, [_c('i', {
      staticClass: "add icon"
    })])])])
  })], 2)]), _vm._v(" "), (_vm.count) ? _c('pagination', {
    key: _vm.customerId,
    attrs: {
      "count": parseInt(_vm.count, 10),
      "current-page": _vm.currentPage
    },
    on: {
      "selectSize": _vm.handleSizeSelect,
      "jumpToPage": _vm.handlePageJump
    }
  }) : _vm._e()], 1) : _vm._e()
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "ui active"
  }, [_c('div', {
    staticClass: "ui inverted loader"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "8"
    }
  }, [_c('div', {
    staticClass: "ui inverted segment"
  }, [_c('p'), _vm._v(" "), _c('div', {
    staticClass: "ui active"
  }, [_c('div', {
    staticClass: "ui inverted loader"
  })])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-38019679","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Cart/FoundProducts.vue
// module id = 492
// module chunks = 1